import { gql } from "apollo-angular";

export const FULL_FRAGMENT_PLAN_STEP_ASSET = gql`
    fragment FullFragmentPlanStepAsset on PlanStepAssetOutput {
        id
        planStepId
        tenantAssetId
    }
`;